var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "volume-control",
      on: {
        mouseenter: _vm.handleVolumeButtonMouseEnter,
        mouseleave: _vm.handleVolumeButtonMouseLeave
      }
    },
    [
      _c("VsIcon", {
        staticClass: "volume-control__button",
        attrs: { icon: "md:volume_" + _vm.volumeIconState },
        nativeOn: {
          click: function($event) {
            return _vm.handleVolumeButtonClicked($event)
          }
        }
      }),
      _vm._v(" "),
      _vm.sliderVisible
        ? _c("div", { staticClass: "volume-control__slider" }, [
            _c("div", { staticClass: "slider" }, [
              _c(
                "div",
                { staticClass: "slider__track" },
                [
                  _c("VsSlider", {
                    staticClass: "slider__manipulator",
                    attrs: { value: _vm.renderVolume, wide: true },
                    on: { input: _vm.changeVolume }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }